import { FormLabel, forwardRef, Switch, SwitchProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import { WithFormControl, WithFormControlProps } from "../WithFormControl";

export interface SwitchFieldProps extends SwitchProps {
  label: ReactNode;
  rootProps?: WithFormControlProps;
}

export const SwitchField = forwardRef<SwitchFieldProps, "input">(
  ({ label, rootProps, ...props }, ref) => {
    return (
      <WithFormControl
        display="flex"
        alignItems="center"
        gap="milli"
        {...rootProps}
      >
        <Switch ref={ref} {...props} />
        <FormLabel>{label}</FormLabel>
      </WithFormControl>
    );
  }
);
